import { useState } from 'react'
import axios from 'axios'

import getCurrentDayForecast from '../helpers/getCurrentDayForecast'
import getCities from '../helpers/getCities'
import getUpcomingDaysForecast from '../helpers/getUpcomingDaysForecast'

const BASE_URL = 'https://api.openweathermap.org/data/2.5/'
const CROSS_DOMAIN = 'https://the-ultimate-api-challenge.herokuapp.com'
const REQUEST_URL = `${CROSS_DOMAIN}/${BASE_URL}`
const API_KEY = '6db4247375d51528a4e204363ffcc678'
const API_IMG_KEY = 'r89yVzlNuZvgCwu-IIfbJ1Sic5-q3QNiPpC-p4qCHIM'

const useForcast = () => {
  const [forecast, setForecast] = useState('')

  const [image, setImage] = useState([])

  const getImage = async (location) => {
    const imageData = await axios(
      `${CROSS_DOMAIN}/https://api.unsplash.com/search/photos?query=${location}&per_page=6&page=1&client_id=${API_IMG_KEY}`
    )

    return imageData
  }

  //Get where on earth id

  const getForcast = async (location) => {
    const { data } = await axios(
      `${REQUEST_URL}/forecast?q=${location}&appid=${API_KEY}&units=metric`
    )
    if (!data || data.length === 0) {
      alert('No city is found')
      return
    }
    return data
  }

  const getForecastdata = (data) => {
    const currentDay = getCurrentDayForecast(data.list[0], data.city)
    setForecast({ currentDay })
  }

  const submitRequest = async (location) => {
    const data = await getForcast(location)
    const imageData = await getImage(location)
    getForecastdata(data)
    setImage({ imageData })
    // const d = imageData.data.results[0]

    // console.log({ d })
  }

  return {
    forecast,
    image,
    submitRequest,
  }
}

export default useForcast
